var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 198,
    viewBox: "0 0 205 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0991,
    y: 23.6406,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2212,
    y: 67.9023,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2212,
    y: 77.165,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2212,
    y: 86.4277,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2212,
    y: 95.6904,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6776 46.8193V47.641C46.6776 48.7304 46.6776 49.9535 46.3241 51.7977L45.1009 51.6735C45.4306 50.0299 45.4449 48.8068 45.4545 47.7844H40.3327V46.8193H46.6776ZM47.4421 52.7055V53.6993H39.5109V52.7055H42.3489V49.7146H43.5625V52.7055H47.4421ZM55.9275 52.7437V53.7184H47.9676V52.7437H51.293V50.7753H52.5065V52.7437H55.9275ZM52.5448 47.1824C52.5448 48.4246 53.6628 49.7337 55.6503 50.0395L55.1343 51.0524C53.6054 50.7753 52.4683 49.9583 51.895 48.8737C51.3217 49.9535 50.1941 50.7801 48.6747 51.0524L48.1587 50.0395C50.1272 49.7337 51.2357 48.415 51.2452 47.1824V46.5613H52.5448V47.1824ZM61.3646 46.6473V47.6219H59.635C59.6446 48.6348 60.2514 49.6143 61.6417 50.0204L61.0588 50.976C60.0985 50.6845 59.4344 50.1016 59.0521 49.3515C58.6651 50.2306 57.958 50.9282 56.9117 51.2722L56.2906 50.3071C57.7335 49.8532 58.3833 48.7256 58.4024 47.6219H56.625V46.6473H61.3646ZM63.3235 46.0644V48.0806H64.4989V49.0744H63.3235V51.2244H62.1004V46.0644H63.3235ZM60.4759 51.3964C62.2819 51.3868 63.4095 52.008 63.4095 53.0686C63.4095 54.1293 62.2819 54.76 60.4759 54.76C58.6317 54.76 57.4946 54.1293 57.4946 53.0686C57.4946 52.008 58.6317 51.3868 60.4759 51.3964ZM60.4759 52.3424C59.3293 52.3424 58.7081 52.5813 58.7177 53.0686C58.7081 53.5655 59.3293 53.814 60.4759 53.814C61.6035 53.814 62.2055 53.5655 62.2055 53.0686C62.2055 52.5813 61.6035 52.3424 60.4759 52.3424Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.0786,
    y: 7.2002,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.2007,
    y: 51.4619,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2007,
    y: 60.7246,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2007,
    y: 69.9873,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2007,
    y: 79.25,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6571 30.3788V31.2006C67.6571 32.2899 67.6571 33.5131 67.3036 35.3573L66.0804 35.2331C66.4101 33.5895 66.4244 32.3664 66.434 31.3439H61.3122V30.3788H67.6571ZM68.4216 36.2651V37.2589H60.4904V36.2651H63.3284V33.2742H64.542V36.2651H68.4216ZM76.907 36.3033V37.278H68.9471V36.3033H72.2725V34.3349H73.486V36.3033H76.907ZM73.5243 30.7419C73.5243 31.9842 74.6423 33.2933 76.6298 33.5991L76.1138 34.612C74.5849 34.3349 73.4478 33.5178 72.8745 32.4333C72.3011 33.5131 71.1736 34.3396 69.6542 34.612L69.1382 33.5991C71.1067 33.2933 72.2151 31.9746 72.2247 30.7419V30.1208H73.5243V30.7419ZM82.3441 30.2068V31.1815H80.6145C80.6241 32.1944 81.2309 33.1738 82.6212 33.58L82.0383 34.5355C81.078 34.2441 80.4139 33.6612 80.0316 32.9111C79.6446 33.7902 78.9375 34.4877 77.8912 34.8317L77.2701 33.8666C78.713 33.4127 79.3627 32.2852 79.3819 31.1815H77.6045V30.2068H82.3441ZM84.303 29.6239V31.6402H85.4783V32.634H84.303V34.784H83.0799V29.6239H84.303ZM81.4554 34.956C83.2614 34.9464 84.389 35.5675 84.389 36.6282C84.389 37.6889 83.2614 38.3195 81.4554 38.3195C79.6112 38.3195 78.4741 37.6889 78.4741 36.6282C78.4741 35.5675 79.6112 34.9464 81.4554 34.956ZM81.4554 35.902C80.3088 35.902 79.6876 36.1409 79.6972 36.6282C79.6876 37.1251 80.3088 37.3735 81.4554 37.3735C82.583 37.3735 83.185 37.1251 83.185 36.6282C83.185 36.1409 82.583 35.902 81.4554 35.902Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.422,
    y: 50.793,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    transform: "rotate(18.5895 120.422 50.793)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 96.9297,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 118.75 96.9297)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.798,
    y: 105.709,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 115.798 105.709)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.845,
    y: 114.489,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 112.845 114.489)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.892,
    y: 123.269,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 109.892 123.269)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.911 83.1489L143.649 83.9278C143.302 84.9603 142.912 86.1196 141.989 87.7549L140.869 87.2472C141.706 85.7945 142.109 84.6398 142.444 83.6737L137.59 82.0409L137.897 81.1262L143.911 83.1489ZM142.759 88.9717L142.443 89.9136L134.925 87.3853L135.242 86.4434L137.932 87.3481L138.885 84.5132L140.036 84.9001L139.082 87.735L142.759 88.9717ZM150.79 91.713L150.479 92.6368L142.935 90.0993L143.245 89.1755L146.397 90.2356L147.025 88.3698L148.175 88.7567L147.547 90.6224L150.79 91.713ZM149.357 85.3634C148.961 86.5408 149.603 88.138 151.389 89.0615L150.577 89.857C149.217 89.107 148.399 87.9701 148.202 86.7594C147.314 87.6 145.982 88.024 144.455 87.7978L144.289 86.6733C146.252 87.0109 147.723 86.1144 148.125 84.9491L148.323 84.3604L149.555 84.7747L149.357 85.3634ZM157.887 87.6678L157.576 88.5917L155.937 88.0403C155.623 89.0034 155.886 90.1252 157.074 90.9533L156.217 91.6732C155.4 91.0908 154.956 90.3266 154.833 89.4938C154.186 90.2037 153.293 90.6394 152.192 90.6319L151.911 89.5192C153.423 89.5489 154.399 88.6873 154.768 87.6473L153.084 87.0807L153.395 86.1569L157.887 87.6678ZM159.929 87.7398L159.287 89.6509L160.401 90.0256L160.084 90.9675L158.97 90.5928L158.284 92.6306L157.125 92.2407L158.77 87.3499L159.929 87.7398ZM155.531 91.8859C157.245 92.4526 158.116 93.4007 157.778 94.4061C157.44 95.4114 156.17 95.6497 154.458 95.074C152.71 94.4861 151.834 93.5258 152.172 92.5205C152.51 91.5151 153.786 91.2889 155.531 91.8859ZM155.229 92.7826C154.142 92.417 153.477 92.4454 153.331 92.9104C153.164 93.3783 153.673 93.8118 154.76 94.1773C155.829 94.5368 156.478 94.4932 156.637 94.0223C156.792 93.5603 156.298 93.142 155.229 92.7826Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.355,
    y: 157.779,
    width: 6.41458,
    height: 40.5167,
    transform: "rotate(-35 56.355 157.779)",
    fill: "#F85B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2506 150.612L61.6107 154.09L56.3434 157.778L55.2506 150.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5337 135.449L105.884 134.543L111.606 174.654L105.255 175.56L99.5337 135.449Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.788 128.558L105.888 134.535L99.5227 135.444L101.788 128.558Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_291",
    x: 14.0991,
    y: 23.6406,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_291",
    x: 35.0786,
    y: 7.2002,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_291",
    x: 89.3804,
    y: 51.5947,
    width: 107.666,
    height: 123.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_291",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcComplaintServiceBodyMobile.4da3948c0d1348582258a73eeec41eb4.svg";
export { ForwardRef as ReactComponent };